import React from 'react';
import Navbar from './components/Navbar';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import './App.css';

import Home from './components/Home';
import AddContact from './components/AddContact';
import EditContact from './components/EditContact';

let App = () => {
  return (
    <>
        <ToastContainer />
        <Navbar />
        <Routes>
            {/* <Route path={'/'} element={<Navigate to={'/contacts/list'} />} /> */}
            <Route path={'/'} element={<Home />} />
            <Route path={'/add'} element={<AddContact />} />
            <Route path={'/edit/:id'} element={<EditContact />} />
        </Routes>
    </>
  );
}

export default App;
